export const VALIDATE_INVITE = 'VALIDATE_INVITE'
export const VALIDATE_INVITE_SUCCES = 'VALIDATE_INVITE_SUCCES'
export const VALIDATE_INVITE_FAILURE = 'VALIDATE_INVITE_FAILURE'
export const REGISTER_INVITE = 'REGISTER_INVITE'
export const REGISTER_INVITE_FAILURE = 'REGISTER_INVITE_FAILURE'
export const REGISTER_INVITE_SUCCESS = 'REGISTER_INVITE_SUCCESS'
export const REGISTER_INVITE_DONE = 'REGISTER_INVITE_DONE'
